import { useState } from 'react'
import { Alert, Col, Form, Modal, Row } from 'react-bootstrap'
import { Search, Tools } from 'react-bootstrap-icons'
import Lottie from 'react-lottie'
import { toast } from 'react-toastify'
import squaresMoving from '../../../assets/lottie/squares-moving.json'
import { Ask } from '../../../components/Ask'
import { CustomButton } from '../../../components/CustomButton'
import { useRandomMessage } from '../../../hooks/useRandomMessage'
import EstruturasService from '../../../services/database/EstruturasService'
import ProdutosService from '../../../services/database/ProdutosService'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

export function ModalAjustar({ isOpen, onClose, kitsSku, skuToRemove }) {
  const [searchSku, setSearchSku] = useState('')
  const [isSearchLoading, setIsSearchLoading] = useState(false)
  const [product, setProduct] = useState({})
  const [isAdjustLoading, setIsAdjustLoading] = useState(false)

  const randomMessage = useRandomMessage()

  async function handleSearch() {
    setProduct({})

    try {
      setIsSearchLoading(true)

      const data = await ProdutosService.getBySKU(searchSku)

      setProduct(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao pesquisar o produto')
    } finally {
      setIsSearchLoading(false)
    }
  }

  async function handleAdjust() {
    try {
      setIsAdjustLoading(true)

      await EstruturasService.adjust(skuToRemove, kitsSku, product.sku)

      toast.success('Os SKUs das composições foram trocados com sucesso')
      onClose()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao ajustar as composições')
    } finally {
      setIsAdjustLoading(false)
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Ajustar Composição</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isAdjustLoading ? (
          <>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: squaresMoving,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice',
                },
              }}
              height={250}
              width={250}
            />

            <h5
              style={{
                textAlign: 'center',
              }}
            >
              {randomMessage}
            </h5>
          </>
        ) : (
          <>
            <Alert variant="warning">
              Uma vez iniciada, essa ação não pode ser desfeita ou cancelada.
              Por favor, confirme todos os dados antes de prosseguir.
            </Alert>

            <Row className="mb-3">
              <Col>
                <Form.Label>SKU da troca</Form.Label>

                <div
                  style={{
                    display: 'flex',
                    alignContent: 'center',
                    gap: 10,
                  }}
                >
                  <Form.Control
                    value={searchSku}
                    onChange={(e) => setSearchSku(e.target.value)}
                    placeholder="Pesquise..."
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && searchSku) {
                        handleSearch()
                      }
                    }}
                  />

                  <CustomButton
                    noMargin
                    title="Pesquisar"
                    onClick={handleSearch}
                    isLoading={isSearchLoading}
                    isLoadingText="Pesquisando..."
                    isDisabled={!searchSku}
                  >
                    <Search />
                  </CustomButton>
                </div>
              </Col>
            </Row>

            {product.sku && (
              <Alert variant="primary">
                Produto selecionado: {product.sku} - {product.descricao}
              </Alert>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          noMargin
          title={
            kitsSku.length > 0
              ? `Ajustar ${kitsSku.length}  ${kitsSku.length > 1 ? 'selecionados' : 'selecionado'}`
              : 'Ajustar'
          }
          isLoading={isAdjustLoading}
          isLoadingText="Ajustando..."
          onClick={() =>
            Ask('Tem certeza que deseja continuar?', () => handleAdjust())
          }
          isDisabled={!product.sku}
        >
          <Tools />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
